import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private readonly _platformId = inject(PLATFORM_ID);
  private darkModeClass = 'dark';

  constructor() {
    if (isPlatformBrowser(this._platformId)) {
      this.loadTheme();
      this.detectSystemTheme();
    }
  }

  toggleTheme(): void {
    if (!isPlatformBrowser(this._platformId)) return;
    document.documentElement.classList.toggle(this.darkModeClass);
    const isDarkMode = document.documentElement.classList.contains(this.darkModeClass);
    localStorage.setItem('theme', isDarkMode ? 'dark' : 'light');
  }

  private loadTheme(): void {
    const storedTheme = localStorage.getItem('theme');
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;

    if (storedTheme === 'dark') {
      document.documentElement.classList.add(this.darkModeClass);
    } else if (storedTheme === 'light') {
      document.documentElement.classList.remove(this.darkModeClass);
    } else if (prefersDark) {
      // Apply system dark preference without saving to localStorage so the
      // matchMedia listener in detectSystemTheme() keeps working.
      document.documentElement.classList.add(this.darkModeClass);
    }
  }

  private detectSystemTheme(): void {
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (event) => {
      // Always follow the OS — update the class and keep localStorage in sync
      // so the next page load also reflects the current OS preference.
      if (event.matches) {
        document.documentElement.classList.add(this.darkModeClass);
        localStorage.setItem('theme', 'dark');
      } else {
        document.documentElement.classList.remove(this.darkModeClass);
        localStorage.setItem('theme', 'light');
      }
    });
  }
}